import { useState, useCallback } from 'react';
import { showGlobalLoading, hideGlobalLoading, setGlobalLoadingText } from '../services/axiosInstance';

/**
 * Hook para controlar o loading global da aplicação
 * @returns {Object} Objeto com funções para controlar o loading
 */
export const useGlobalLoading = () => {
  const [isLoading, setIsLoading] = useState(false);

  const startLoading = useCallback((text = '') => {
    setIsLoading(true);
    showGlobalLoading(text);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
    hideGlobalLoading();
  }, []);

  const updateLoadingText = useCallback((text) => {
    setGlobalLoadingText(text);
  }, []);

  return {
    isLoading,
    startLoading,
    stopLoading,
    updateLoadingText,
  };
};

export default useGlobalLoading;
